import React from 'react';
import { Card, ExamTable } from 'components';
import { NeedingAttentionMappedExamStatuses } from 'components/enums';
import { IExam } from '../../api/ApiClient';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { getExamTimesLeftSubStatus } from '_helpers';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';
import query from '../../helpers/const/query';

const ExamsInProcessingContainer = ({
    setErrorHandler,
    onFetchExamsInProcessing,
    onPush,
    apiError,
    loading,
    examsInProcessingList,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const HEADER = [
        'ПЕРИОД ПРОВЕДЕНИЯ',
        'Специальность',
        'Требуется',
    ];

    React.useEffect(() => {
        onFetchExamsInProcessing();
    }, []);

    const handleChooseExam = (id?: string) => {
        if (!id) return;
        onPush(`/exam/${id}?from=${query.FROM.EXAM_IN_PROGRESS}`);
    };

    const getExamData = (exam: IExam) => {
        const status = NeedingAttentionMappedExamStatuses[exam.status];
        const subStatus = getExamTimesLeftSubStatus(exam);

        return {
            ...exam,
            status: { ...status, subStatus },
            name: exam.qualificationTitle,
        };
    };

    return (
        <Card
          withoutPadding
          title="Обработка аккредитаций"
          category="Список аккредитаций в процессе обработки"
          apiError={apiError}
          showLoader={loading}
        >
            <ExamTable
              header={HEADER}
              tableRows={(examsInProcessingList || []).map(getExamData)}
              onChooseExam={handleChooseExam}
              placeholderTitle="Нет аккредитаций в списке"
              placeholderText="Здесь будут отображаться все аккредитации, ожидающие обработки"
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    examsInProcessingList: state.exams.examsInProcessingList,
    apiError: state.errors.error,
    loading: Boolean(state.loading.effects.exams.fetchExamsInProcessing),
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    setErrorHandler: dispatch.errors.setErrorHandler,
    onFetchExamsInProcessing: dispatch.exams.fetchExamsInProcessing,
});

export default connect(mapState, mapDispatch)(ExamsInProcessingContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;
